import React from "react";
import ViewUserRoleDetailsLayout from "../../layouts/ViewUserRoleDetailsLayout";
import ViewFieldContainer from "../../containers/ViewFieldContainer";
import {
  getLocalizedMessage,
  getValueOnCondition,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

export default function ViewUserRoleDetailsContainer({ userData }) {
  const isRoleIncluded = (array, roleName) => {
    return array?.some((item) => item.name === roleName);
  };

  const intl = useIntl();
  const operationAuditTM = checkOperationAuditForTM(userData?.roles, "TM");
  const repairAuditTM = checkRepairAuditForTM(userData?.roles, "TM");
  const isDNSDRoleIncluded = isRoleIncluded(userData?.roles, "DNSD");
  const isTMRoleIncluded = isRoleIncluded(userData?.roles, "TM");
  const onlyDNSDRoleSelected =
    isDNSDRoleIncluded && userData?.roles?.length === 1;
  const onlyMainAdminRoleSelected =
    isRoleIncluded(userData?.roles, "ADMIN") && userData?.roles?.length === 1;

  const getComma = (operAudit, repairAudit) => {
    return operAudit?.length > 0 && repairAudit?.length > 0 ? "," : "";
  };

  return (
    <ViewUserRoleDetailsLayout
      onlyDNSDRoleSelected={onlyDNSDRoleSelected}
      isTMRoleIncluded={isTMRoleIncluded}
      isDNSDRoleIncluded={isDNSDRoleIncluded}
      roleNameSection={
        <ViewFieldContainer
          displayProperty={getLocalizedMessage(
            intl,
            "viewUserDetails.text.roleName"
          )}
          displayValue={userData?.roles
            ?.map((role) => role?.fullName)
            .join(", ")}
        />
      }
      employeeIdSection={
        <ViewFieldContainer
          displayProperty={getLocalizedMessage(
            intl,
            "addUser.addUserEmployeeId"
          )}
          displayValue={getValueOnCondition({
            condition: userData?.employeeId === null,
            trueValue: "-",
            falseValue: userData?.employeeId,
          })}
        />
      }
      countrySection={getValueOnCondition({
        condition: !onlyMainAdminRoleSelected,
        trueValue: (
          <ViewFieldContainer
            displayProperty={getLocalizedMessage(intl, "addUser.label.country")}
            displayValue={userData?.country?.name}
          />
        ),
        falseValue: null,
      })}
      auditSectionTM={
        getValueOnCondition({
          condition: isTMRoleIncluded,
          trueValue: (
            <ViewFieldContainer
              displayProperty={getLocalizedMessage(
                intl,
                "addUser.text.operationAndRepairAudit"
              )}
              displayValue={
                operationAuditTM?.length > 0 || repairAuditTM?.length > 0
                  ? operationAuditTM +
                    getComma(operationAuditTM, repairAuditTM) +
                    repairAuditTM
                  : "-"
              }
            />
          ),
          falseValue: null,
        })
      }
      globalIdSection={getValueOnCondition({
        condition: isDNSDRoleIncluded,
        trueValue: (
          <ViewFieldContainer
            displayProperty={getLocalizedMessage(intl, "addUser.addGlobalID")}
            displayValue={getValueOnCondition({
              condition: userData?.globalId === null,
              trueValue: "-",
              falseValue: userData?.globalId,
            })}
          />
        ),
        falseValue: null,
      })}
      auditSectionDNSD={getValueOnCondition({
        condition: isDNSDRoleIncluded,
        trueValue: (
          <ViewFieldContainer
            displayProperty={getLocalizedMessage(
              intl,
              "viewUserDetails.repairAuditDone"
            )}
            displayValue={checkRepairAuditForDNSD(userData?.roles, "DNSD")}
          />
        ),
        falseValue: null,
      })}
    />
  );
}

const checkRepairAuditForDNSD = (roles, roleName) => {
  const repairAuditValue = roles?.find(
    (role) => role.name === roleName
  )?.isRepairAudit;
  if (repairAuditValue) {
    return "Yes";
  } else {
    return "No";
  }
};

const checkRepairAuditForTM = (roles, roleName) => {
  const repairAuditValue = roles?.find(
    (role) => role.name === roleName
  )?.isRepairAudit;
  if (repairAuditValue) {
    return "Repair Audit";
  } else {
    return "";
  }
};

const checkOperationAuditForTM = (roles, roleName) => {
  const operationAuditValue = roles?.find(
    (role) => role.name === roleName
  )?.isOperationsAudit;
  if (operationAuditValue) {
    return "Operation Audit";
  } else {
    return "";
  }
};